import { TabMenu } from 'primereact/tabmenu';
import { useState } from 'react';
import { LubematchSearch } from './LubematchSearch/LubematchSearch';
import styles from './LubematchPage.module.css'
import { LubematchHistory } from './LubematchHistory/LubematchHistory';

export const LubematchPage = () => {
    const items = [
        {label:'Пошук', icon: 'pi pi-search', name:'search', index:0},
        {label:'Історія', icon: 'pi pi-history', name:'history', index:1}
    ];

    const [menuItemActiveIndex, setMenuItemActiveIndex] = useState(0);

    return (
        <div className={styles.lubemathPageWrapper}>
            <TabMenu  model={items} activeIndex={menuItemActiveIndex} onTabChange={(item) => {setMenuItemActiveIndex(item.index)}} />
            <div style={{width:'100%'}}>
                <div style={{ display: menuItemActiveIndex === 0 ? 'block' : 'none' }} aria-hidden={menuItemActiveIndex !== 0}>
                    <LubematchSearch />
                </div>
                <div style={{ display: menuItemActiveIndex === 1 ? 'block' : 'none' }} aria-hidden={menuItemActiveIndex !== 1}>
                    <LubematchHistory isActive={menuItemActiveIndex === 1} />
                </div>
            </div>
        </div>
    )
}
